<template>
  <div class="p-5">
    <el-alert v-if="showLoginErrorAlert" :title="loginErrorMessage" type="error" :closable="false"> </el-alert>
    <el-form class="apply-form first-form" :model="loginForm" :rules="rule" ref="loginForm">
      <el-form-item label="Email" prop="email">
        <el-input placeholder="Enter your email" v-model="loginForm.email"></el-input>
      </el-form-item>
      <el-form-item class="input-password" label="Password" prop="password">
        <el-input type="password" placeholder="Enter your Password" v-model="loginForm.password"></el-input>
      </el-form-item>
      <el-form-item class="mt-4">
        <el-button type="primary" @click="login('loginForm')">Login</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import router from '../app-router';
import {
  GENERIC_LOGIN_ERROR_MESSAGE,
  REQUIRED_FIELD_RULE,
  USER_NOT_FOUND_MESSAGE,
  VALIDATION_TRIGGERS,
} from '../constants';
import { authService } from '../services';
import { emailValidator } from '../validators';
import { UserNotFoundException } from '../models/api/exceptions';

export default defineComponent({
  name: 'login',
  data: function () {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      rule: {
        email: {
          required: true,
          validator: emailValidator,
          trigger: VALIDATION_TRIGGERS.BLUR,
        },
        password: REQUIRED_FIELD_RULE,
      },
      showLoginErrorAlert: false,
      // FIX-ME this error will depend on error message that comes from backend
      loginErrorMessage: GENERIC_LOGIN_ERROR_MESSAGE,
    };
  },
  methods: {
    login: function (formName) {
      (this.$refs[formName] as HTMLFormElement).validate(async (valid) => {
        try {
          if (!valid) {
            return false;
          }
          this.showLoginErrorAlert = false;
          await authService.login(this.loginForm.email, this.loginForm.password);
          await router.push('/tsas/admin');
        } catch (error) {
          this.showLoginErrorAlert = true;
          if (error instanceof UserNotFoundException) {
            this.loginErrorMessage = USER_NOT_FOUND_MESSAGE;
            return;
          }
          this.loginErrorMessage = GENERIC_LOGIN_ERROR_MESSAGE;
        }
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 10px;
  display: block;
}
.el-form-item.is-error {
  margin-bottom: 22px;
}
.el-form-item.input-password {
  margin-bottom: 1.5rem;
}
.el-form-item.is-error.input-password {
  margin-bottom: 2.5rem;
}
</style>
